import { ArticleHeading2, Label, Paragraph2, UIHeading2 } from '@cian/ui-kit';
import classNames from 'classnames';
import React, { memo } from 'react';

import styles from './Price.css';
import { IDiscount } from '../../types/offer';
import { ContentRow } from '../ContentRow';
import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';

interface IPriceProps {
  priceInfo?: string;
  price: string;
  discount?: IDiscount;
  isHighlighted?: boolean;
  isMuted?: boolean;
  MortgageAdFoxBanner?: React.ReactNode;
  mortgagePayment?: React.ReactNode;
}

const defaultColors = {
  bgColor: 'accent-positive-primary',
  color: 'text-inverted-default',
  strikethroughColor: 'accent-positive-primary',
};

/** Компонент цены */
export const PriceComponent: React.FC<IPriceProps> = ({
  priceInfo,
  price,
  isHighlighted,
  isMuted,
  MortgageAdFoxBanner,
  discount,
  mortgagePayment,
}) => {
  return (
    <GeneralInfoSectionRow>
      <div className={styles['price-wrapper']}>
        <div className={discount ? undefined : styles['main-price']}>
          <ContentRow>
            {discount ? (
              <div className={styles['price-container']} data-testid="offer-discount-block">
                <ArticleHeading2
                  color={isMuted ? 'text-secondary-default' : 'text-primary-default'}
                  data-mark="DiscountPrice"
                >
                  <span
                    className={classNames(isHighlighted && /* istanbul ignore next*/ styles['highlighted'])}
                    data-testid="offer-discount-new-price"
                  >
                    {discount.newPrice}
                  </span>
                </ArticleHeading2>
                <div className={styles['discount']}>
                  <Label
                    background={defaultColors.bgColor}
                    color={defaultColors.color}
                    data-testid="offer-discount-label"
                  >
                    {discount.percent}
                  </Label>
                  <span
                    className={styles['strikethrough']}
                    data-testid="offer-discount-old-price"
                    style={{ textDecorationColor: `var(--${defaultColors.strikethroughColor})` }}
                  >
                    {discount.oldPrice}
                  </span>
                </div>
              </div>
            ) : (
              <UIHeading2 data-mark="MainPrice" color={isMuted ? 'text-secondary-default' : 'text-primary-default'}>
                <span className={classNames(isHighlighted && /* istanbul ignore next*/ styles['highlighted'])}>
                  {price}
                </span>
              </UIHeading2>
            )}
          </ContentRow>
          {priceInfo && (
            <ContentRow>
              <Paragraph2 data-mark="PriceInfo" color="gray60_100">
                {priceInfo}
              </Paragraph2>
            </ContentRow>
          )}
        </div>

        {mortgagePayment}
      </div>
      {MortgageAdFoxBanner}
    </GeneralInfoSectionRow>
  );
};

PriceComponent.displayName = 'Price';

/** @see {@link PriceComponent} */
export const Price = memo(PriceComponent);
